module.exports = __webpack_public_path__ + "img/hymn-icon.e9b76cc5.png";